// src/pages/JeuxVideos.jsx
import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { CartContext } from '../context/CartContext';
import { FavoritesContext } from '../context/FavoritesContext';
import Footer from './Footer';
import { Blocks } from 'react-loader-spinner';
import SEO from '../components/SEO.jsx';
import { API_URL } from '../config/api';

const ITEMS_PER_PAGE = 12; // Nombre d’articles par page

export default function CD() {
  const { dispatch: cartDispatch } = useContext(CartContext);
  const { favorites } = useContext(FavoritesContext);

  const [filter, setFilter] = useState(false);
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [originalProducts, setOriginalProducts] = useState([]);

  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [platforms, setPlatforms] = useState([]);

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedPlatforms, setSelectedPlatforms] = useState([]);
  const [priceRange, setPriceRange] = useState([0, 100000]);
  const [sortOrder, setSortOrder] = useState('asc');

  const [currentPage, setCurrentPage] = useState(1);

  // 1. Charger les données PS5 depuis l’API
  useEffect(() => {
    fetch(`${API_URL}/products`)
      .then((r) => r.json())
      .then((all) => {
        // Filtrer les produits PS5 (insensible à la casse)
        const filtered = all.filter(
          (p) => (p.groupe || '').toLowerCase() === 'cd'
        );
        setOriginalProducts(filtered);
        setCurrentPage(1);

        setCategories([...new Set(filtered.map((j) => j.categorie))]);
        setBrands([...new Set(filtered.map((j) => j.label))]);
        setPlatforms([...new Set(filtered.map((j) => j.plateforme || j.groupe))]);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  // 2. Appliquer les filtres et le tri sur originalProducts
  useEffect(() => {
    let filtered = [...originalProducts];

    if (selectedCategories.length)
      filtered = filtered.filter((j) => selectedCategories.includes(j.categorie));

    if (selectedBrands.length)
      filtered = filtered.filter((j) => selectedBrands.includes(j.label));

    if (selectedPlatforms.length)
      filtered = filtered.filter((j) =>
        selectedPlatforms.includes(j.plateforme || j.groupe)
      );

    filtered = filtered.filter(
      (j) => j.price >= priceRange[0] && j.price <= priceRange[1]
    );

    filtered.sort((a, b) => {
      if (sortOrder === 'nameAsc') return a.title.localeCompare(b.title);
      return sortOrder === 'asc' ? a.price - b.price : b.price - a.price;
    });

    setProducts(filtered);
    setCurrentPage(1); // reset page quand filtre change
  }, [
    selectedCategories,
    selectedBrands,
    selectedPlatforms,
    priceRange,
    sortOrder,
    originalProducts,
  ]);

  // Pagination : découpage des produits à afficher sur la page courante
  const totalPages = Math.ceil(products.length / ITEMS_PER_PAGE);
  const paginatedProducts = products.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  // Helpers toggle pour checkbox
  const toggleArray = (arrSetter) => (val) =>
    arrSetter((arr) => (arr.includes(val) ? arr.filter((x) => x !== val) : [...arr, val]));

  const handlePriceRangeChange = (e) =>
    setPriceRange((r) =>
      e.target.name === 'min'
        ? [Number(e.target.value), r[1]]
        : [r[0], Number(e.target.value)]
    );

  const closeFilter = () => setFilter(false);
  const showFilter = () => setFilter(true);

  return (
    <div className="jeux-bg">
      <SEO
        title="CD & Consoles"
        description="Découvrez notre sélection de CD et consoles de jeux vidéo au meilleur prix sur CodeShop225."
        path="/CD"
      />
      <div className="container">
        <nav aria-label="breadcrumb" className="breadcrumb-container">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/">Accueil</Link></li>
            <li className="breadcrumb-item active" aria-current="page">Jeux CD </li>
          </ol>
        </nav>

        <div className="header__picture">
          <img src="/header.jpg" alt="Jeux PS5" className="header__img" />
          <div className="header__overlay">
            <h2 className="header__accessories">Jeux CD </h2>
          </div>
        </div>

        <div className="box__filter" onMouseOver={showFilter}>
          <i className="fa-solid fa-arrow-up-wide-short"></i>
          <p>Filtre</p>
        </div>

        <div className="filter-mld">
          {/* Filtres visibles (desktop) */}
          <div className="filter--container p-6 bg-white shadow-md rounded-2xl space-y-6 w-full max-w-sm text-gray-800">
            <h2 className="filter__title">🎮 {products.length} résultat(s)</h2>

            {/* Console */}
            {/* <div className="filter__block">
              <h4>🕹️ Console</h4>
              <div className="filter__options">
                {platforms.map((plat, i) => (
                  <label key={i}>
                    <input
                      type="checkbox"
                      checked={selectedPlatforms.includes(plat)}
                      onChange={() => toggleArray(setSelectedPlatforms)(plat)}
                    />
                    {plat}
                  </label>
                ))}
              </div>
            </div> */}

            {/* Catégories */}
            <div className="filter__block">
              <h4>📂 Catégories</h4>
              <div className="filter__options">
                {categories.map((c, i) => (
                  <label key={i}>
                    <input
                      type="checkbox"
                      checked={selectedCategories.includes(c)}
                      onChange={() => toggleArray(setSelectedCategories)(c)}
                    />
                    {c}
                  </label>
                ))}
              </div>
            </div>

            {/* Marques */}
            <div className="filter__block">
              <h4>🏷️ Marques</h4>
              <div className="filter__options">
                {brands.map((b, i) => (
                  <label key={i}>
                    <input
                      type="checkbox"
                      checked={selectedBrands.includes(b)}
                      onChange={() => toggleArray(setSelectedBrands)(b)}
                    />
                    {b}
                  </label>
                ))}
              </div>
            </div>

            {/* Prix */}
            <div className="filter__block">
              <h4>💰 Prix</h4>
              <div className="price__inputs">
                <input
                  type="number"
                  placeholder="Min"
                  name="min"
                  value={priceRange[0]}
                  onChange={handlePriceRangeChange}
                />
                <input
                  type="number"
                  placeholder="Max"
                  name="max"
                  value={priceRange[1]}
                  onChange={handlePriceRangeChange}
                />
              </div>
            </div>

            {/* Trier */}
            <div className="filter__block">
              <h4>🔽 Trier par</h4>
              <select
                value={sortOrder}
                onChange={(e) => setSortOrder(e.target.value)}
              >
                <option value="asc">Prix croissant</option>
                <option value="desc">Prix décroissant</option>
                <option value="nameAsc">Nom A-Z</option>
              </select>
            </div>
          </div>

          {/* Sidebar responsive */}
          <div className={filter ? 'filterbar show--filterbar' : 'filterbar'}>
            <div className="filterbar__content">
              <div className="filterbar__close" onClick={closeFilter}>
                <i className="fa-solid fa-xmark"></i>
              </div>

              <div className="filterbar__container">
                <h2 className="filter__title">🎮 {products.length} résultat(s)</h2>

                {/* Console */}
                <div className="filter__block">
                  <h4>🕹️ Console</h4>
                  <div className="filter__options">
                    {platforms.map((plat, i) => (
                      <label key={i}>
                        <input
                          type="checkbox"
                          checked={selectedPlatforms.includes(plat)}
                          onChange={() => toggleArray(setSelectedPlatforms)(plat)}
                        />
                        {plat}
                      </label>
                    ))}
                  </div>
                </div>

                {/* Catégories */}
                <div className="filter__block">
                  <h4>📂 Catégories</h4>
                  <div className="filter__options">
                    {categories.map((c, i) => (
                      <label key={i}>
                        <input
                          type="checkbox"
                          checked={selectedCategories.includes(c)}
                          onChange={() => toggleArray(setSelectedCategories)(c)}
                        />
                        {c}
                      </label>
                    ))}
                  </div>
                </div>

                {/* Marques */}
                <div className="filter__block">
                  <h4>🏷️ Marques</h4>
                  <div className="filter__options">
                    {brands.map((b, i) => (
                      <label key={i}>
                        <input
                          type="checkbox"
                          checked={selectedBrands.includes(b)}
                          onChange={() => toggleArray(setSelectedBrands)(b)}
                        />
                        {b}
                      </label>
                    ))}
                  </div>
                </div>

                {/* Prix */}
                <div className="filter__block">
                  <h4>💰 Prix</h4>
                  <div className="price__inputs">
                    <input
                      type="number"
                      placeholder="Min"
                      name="min"
                      value={priceRange[0]}
                      onChange={handlePriceRangeChange}
                    />
                    <input
                      type="number"
                      placeholder="Max"
                      name="max"
                      value={priceRange[1]}
                      onChange={handlePriceRangeChange}
                    />
                  </div>
                </div>

                {/* Trier */}
                <div className="filter__block">
                  <h4>🔽 Trier par</h4>
                  <select
                    value={sortOrder}
                    onChange={(e) => setSortOrder(e.target.value)}
                  >
                    <option value="asc">Prix croissant</option>
                    <option value="desc">Prix décroissant</option>
                    <option value="nameAsc">Nom A-Z</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* Grille des produits */}
          <div className="filter--right">
            {loading ? (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: 300,
                  color: '#555',
                }}
              >
                <Blocks
                  visible={true}
                  height={80}
                  width={80}
                  ariaLabel="blocks-loading"
                  wrapperStyle={{}}
                  wrapperClass="blocks-wrapper"
                />
                <p style={{ marginTop: 15, fontSize: '1.1rem' }}>
                  Chargement des produits...
                </p>
              </div>
            ) : paginatedProducts.length === 0 ? (
              <div
                style={{
                  minHeight: 300,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  // color: '#999',
                  fontSize: '1.2rem',
                  fontStyle: 'italic',
                }}
              >
                Aucun produit trouvé avec les filtres sélectionnés.
              </div>
            ) : (
              <>
                <div className="pro-grid">
                  {paginatedProducts.map((prod) => {
                    const isFav = favorites.some((f) => f._id === prod._id);
                    return (
                       <article key={prod._id} className="pro-card">
                        <Link
                          to={`/product/${prod._id}`}
                          className="pro-imgWrap"
                        >
                          <img
                            src={prod.img.startsWith('http') ? prod.img : `${API_URL}/uploads/${prod.img}`}
                            alt={prod.title}
                          />

                          <div className="pro-badges">
                            <span className={`pro-badge ${prod.promotion > 0 ? 'promo' : 'empty'}`}>
                              {prod.promotion > 0 ? `-${prod.promotion}%` : ' '}
                            </span>
                            <span className={`pro-badge ${prod.nouveaute > 0 ? 'nouveaute' : 'empty'}`}>
                              {prod.nouveaute > 0 ? 'Nouveauté' : ' '}
                            </span>
                          </div>
                        </Link>

                      <div className="pro-info">
                        <h4 className="pro-title">{prod.title}</h4>
                        <p className="pro-meta">
                          {prod.label} • {prod.categorie} • {prod.plateforme || prod.groupe}
                        </p>

          <div className="pro-footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  <div className="pro-price-wrapper" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
    {prod.promotion > 0 && prod.prixOriginal > 0 ? (
      <>
        <span className="original-price" style={{ textDecoration: 'line-through', color: '#888', fontWeight: '500', fontSize: '0.95rem' }}>
          {Number(prod.prixOriginal).toLocaleString()} FCFA
        </span>
        <span className="promo-price pro-price" style={{ color: '#e53935' }}>
          {Number(prod.price).toLocaleString()} FCFA
        </span>
        
      </>
    ) : (
      <span className="pro-price">
        {Number(prod.prixOriginal > 0 ? prod.prixOriginal : prod.price).toLocaleString()} FCFA
      </span>
    )}
  </div>

  <div className="pro-actions">
    <button className="circle-btn" onClick={() => cartDispatch({ type: 'ADD_TO_CART', payload: prod })}>
      <i className="fa-solid fa-cart-plus" />
    </button>
  </div>
</div>
                      </div>
                      </article>
                    );
                  })}
                </div>

                {totalPages > 1 && (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
    gap: '8px'
  }}>
    {Array.from({ length: totalPages }, (_, i) => (
      <button
        key={i}
        onClick={() => setCurrentPage(i + 1)}
        style={{
          padding: '8px 14px',
          borderRadius: '8px',
          border: currentPage === i + 1 ? '1px solid #2563eb' : '1px solid #ddd',
          backgroundColor: currentPage === i + 1 ? '#2563eb' : '#f9fafb',
          color: currentPage === i + 1 ? '#fff' : '#374151',
          fontWeight: currentPage === i + 1 ? '600' : '400',
          boxShadow: currentPage === i + 1 ? '0 4px 10px rgba(37, 99, 235, 0.3)' : 'none',
          cursor: 'pointer',
          transition: 'all 0.2s ease'
        }}
      >
        {i + 1}
      </button>
    ))}
  </div>
)}
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}